import * as siteTypes from './types/list'
import * as zones from './zones/list'

import * as clients from 'app/mocks/data/park/clients/list'
import * as lambdas from 'app/mocks/data/users/konsole/lambdas'

import { Country, Site } from 'app/types/park/site'

export const site1: Site = {
    id: 1,
    name: 'Carrefour Bruxelles',
    description: '',
    customer_name: clients.client1,
    site_type: siteTypes.siteType1,
    zone: zones.zone1,
    address: '2 Rue de la Madeleine',
    postal_code: '10000',
    city: 'Bruxelles',
    country: Country.enum.BELGIUM,
    building_floor: '',
    latitude: 50.846_223_7,
    longitude: 4.354_776_5,
    further_information: '',
    supply_days: 'mo,we,fr',
    opening_hours: '09:00:00',
    closing_hours: '19:00:00',
    supervisor: lambdas.lambda1,
    has_order: true,
}

export const site2: Site = {
    id: 2,
    name: 'Carrefour Market Eurocontrol',
    description: '',
    customer_name: clients.client1,
    site_type: siteTypes.siteType1,
    zone: zones.zone2,
    address: '40 rue du marché aux poulets',
    postal_code: '1000',
    city: 'Bruxelles',
    country: Country.enum.BELGIUM,
    building_floor: '',
    latitude: 50.848_645_1,
    longitude: 4.351_276_8,
    further_information: '',
    supply_days: 'tu,th,sa',
    opening_hours: '09:00:00',
    closing_hours: '20:00:00',
    supervisor: lambdas.lambda2,
    has_order: true,
}

export const site3: Site = {
    id: 3,
    name: 'Enedis Vannes',
    description: '',
    customer_name: clients.client1,
    site_type: siteTypes.siteType1,
    zone: zones.zone3,
    address: '9 rue des cerisiers',
    postal_code: '91090',
    city: 'Lisses',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 48.596_602_4,
    longitude: 2.435_742_5,
    further_information: '',
    supply_days: 'mo',
    opening_hours: '09:00:00',
    closing_hours: '19:00:00',
    supervisor: lambdas.lambda1,
    has_order: true,
}

export const site4: Site = {
    id: 4,
    name: 'ethik',
    description: '',
    customer_name: clients.client1,
    site_type: siteTypes.siteType36,
    zone: zones.zone3,
    address: '103 Rue Charles Michels',
    postal_code: '93200',
    city: 'St Denis',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 48.928_631_2,
    longitude: 2.343_926_418_704_376,
    further_information: '',
    supply_days: 'mo,tu,we,th,fr,sa',
    opening_hours: '11:20:00',
    closing_hours: '11:20:00',
    supervisor: lambdas.lambda1,
    has_order: true,
}

export const site5: Site = {
    id: 5,
    name: 'e-thik Show Room',
    description: 'Pizza',
    customer_name: clients.client1,
    site_type: siteTypes.siteType35,
    zone: zones.zone4,
    address: '9 Rue des Cerisiers',
    postal_code: '91090',
    city: 'Lisses',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 48.596_602_4,
    longitude: 2.435_742_5,
    further_information: '',
    supply_days: 'mo,we,fr,th',
    supervisor: lambdas.lambda1,
    has_order: true,
}

export const site6: Site = {
    id: 6,
    name: 'FAC DE SCIENCES  Bat A',
    description: '',
    customer_name: clients.client2,
    site_type: siteTypes.siteType33,
    zone: zones.zone2,
    address: '9',
    postal_code: '75000',
    city: 'Paris',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 48.853_495_1,
    longitude: 2.348_391_5,
    further_information: '',
    supply_days: 'mo,tu,we,th,fr,sa,su',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site7: Site = {
    id: 7,
    name: 'FAC DE SCIENCES  Bat E',
    description: '',
    customer_name: clients.client2,
    zone: zones.zone4,
    address: '3',
    postal_code: '75000',
    city: 'Paris',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 48.846_698_75,
    longitude: 2.252_604_434_669_352,
    further_information: '',
    supply_days: 'mo,tu,we,th,fr,sa,su',
    opening_hours: '08:00:00',
    closing_hours: '17:00:00',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site8: Site = {
    id: 8,
    name: 'FAC DE SCIENCES  Bat L',
    description: '',
    customer_name: clients.client3,
    site_type: siteTypes.siteType33,
    zone: zones.zone2,
    address: '6',
    postal_code: '75000',
    city: 'Paris',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 48.853_495_1,
    longitude: 2.348_391_5,
    further_information: '',
    supply_days: 'mo,tu,we,th,fr,sa,su',
    opening_hours: '08:00:00',
    closing_hours: '17:00:00',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site9: Site = {
    id: 9,
    name: 'Free Go chez JLP',
    description: '',
    customer_name: clients.client3,
    site_type: siteTypes.siteType1,
    zone: zones.zone1,
    address: 'la borde',
    postal_code: '85600',
    city: 'Montaigu en vendée',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 46.937_024_050_000_005,
    longitude: -1.244_265_360_925_936_2,
    further_information: '',
    supply_days: 'mo,tu,we,th,fr',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site10: Site = {
    id: 10,
    name: 'Gare du Nord',
    description: 'Site de test 2',
    customer_name: clients.client3,
    site_type: siteTypes.siteType34,
    zone: zones.zone4,
    address: 'rue du nord',
    postal_code: '59000',
    city: 'Lille',
    country: Country.enum.FRANCE,
    latitude: 50.669_344_1,
    longitude: 2.970_949_4,
    supply_days: 'mo,sa',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site11: Site = {
    id: 11,
    name: 'graillance',
    description: '',
    customer_name: clients.client11,
    site_type: siteTypes.siteType4,
    zone: zones.zone5,
    address: '27 Rue Amédée Fraguier',
    postal_code: '91250',
    city: 'Tigery',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 48.636_706_7,
    longitude: 2.510_262_2,
    further_information: '',
    supply_days: 'mo',
    supervisor: lambdas.lambda7,
    has_order: true,
}

export const site12: Site = {
    id: 12,
    name: 'KIS',
    description: '',
    customer_name: clients.client11,
    site_type: siteTypes.siteType4,
    zone: zones.zone6,
    address: '7 Rue Jean-Pierre Timbaud',
    postal_code: '38130',
    city: 'Échirolles',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 45.139_498,
    longitude: 5.710_864_7,
    further_information: '',
    supply_days: 'mo,tu,we,th,fr',
    supervisor: lambdas.lambda7,
    has_order: true,
}

export const site13: Site = {
    id: 13,
    name: 'Labo',
    description: 'Frigo de test e-thik',
    customer_name: clients.client12,
    site_type: siteTypes.siteType3,
    zone: zones.zone5,
    address: '1 rue Jules Serval',
    postal_code: '69259',
    city: 'Vénissieux',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 45.707_699_9,
    longitude: 4.872_791_3,
    further_information: '',
    supply_days: 'mo,tu,we,th,fr,sa,su',
    supervisor: lambdas.lambda3,
    has_order: true,
}

export const site14: Site = {
    id: 14,
    name: 'Mairie de Marcoussis',
    description: '',
    customer_name: clients.client12,
    site_type: siteTypes.siteType37,
    zone: zones.zone9,
    address: '10 rue des deux puits',
    postal_code: '91460',
    city: 'marcoussis',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 48.639_596_9,
    longitude: 2.227_146,
    further_information: '',
    supply_days: 'mo',
    supervisor: lambdas.lambda1,
    has_order: true,
}

export const site15: Site = {
    id: 15,
    name: 'Salon Europain',
    description: '',
    customer_name: clients.client13,
    site_type: siteTypes.siteType4,
    zone: zones.zone7,
    address: 'Porte de Versailles',
    postal_code: '75018',
    city: 'Paris',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 48.832_433_8,
    longitude: 2.287_953_7,
    further_information: '',
    supply_days: 'su,sa,fr,th,mo,tu',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site16: Site = {
    id: 16,
    name: 'sdf',
    description: '',
    customer_name: clients.client16,
    site_type: siteTypes.siteType5,
    zone: zones.zone8,
    address: 's',
    postal_code: '65432',
    city: 'sdf',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 25.305_754_75,
    longitude: 60.631_667_524_535_36,
    further_information: '',
    supply_days: 'mo',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site17: Site = {
    id: 17,
    name: 'Serbotel',
    description: '',
    customer_name: clients.client16,
    site_type: siteTypes.siteType5,
    zone: zones.zone33,
    address: 'PArc des expositions',
    postal_code: '44000',
    city: 'NAntes',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 47.219_765_65,
    longitude: -1.542_945_387_088_528,
    further_information: '',
    supply_days: 'mo,tu,we,th,fr,sa,su',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site18: Site = {
    id: 18,
    name: 'JP Morgan',
    description: '',
    customer_name: clients.client17,
    site_type: siteTypes.siteType5,
    zone: zones.zone34,
    address: '9 rue des cerisiers',
    postal_code: '91090',
    city: 'Lisses',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 48.596_602_4,
    longitude: 2.435_742_5,
    further_information: '',
    supply_days: 'mo,tu,we,th,fr',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site19: Site = {
    id: 19,
    name: 'Bijou',
    description: 'test',
    customer_name: clients.client17,
    site_type: siteTypes.siteType5,
    zone: zones.zone35,
    address: '13 All. François Mitterrand',
    postal_code: '49100',
    city: 'ANGERS',
    country: Country.enum.FRANCE,
    building_floor: '',
    latitude: 47.478_642_4,
    longitude: -0.549_121_3,
    further_information: '',
    supply_days: 'mo,tu,we,th,fr,sa,su',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site20: Site = {
    id: 20,
    name: 'Hospital de la Salpestrière',
    description: 'WebHook for the credit refill of Konvives',
    customer_name: clients.client18,
    site_type: siteTypes.siteType38,
    zone: zones.zone35,
    address: 'Av. Minerve 21',
    postal_code: '1450',
    city: 'Chastre',
    country: Country.enum.BELGIUM,
    building_floor: '',
    latitude: 50.606_682_500_000_005,
    longitude: 4.643_459_914_745_515,
    further_information: '',
    supply_days: 'mo,tu,we,fr,th,sa,su',
    supervisor: lambdas.lambda1,
    has_order: false,
}

export const site21: Site = {
    id: 21,
    name: 'Renault Douai',
    description: 'WebHook for the credit refill of Konvives',
    customer_name: clients.client21,
    site_type: siteTypes.siteType8,
    zone: zones.zone10,
    address: 'Av. Minerve 21',
    postal_code: '1450',
    city: 'Chastre',
    country: Country.enum.BELGIUM,
    building_floor: '',
    latitude: 50.606_682_500_000_005,
    longitude: 4.643_459_914_745_515,
    further_information: '',
    supply_days: 'mo,tu,we,fr,th,sa,su',
    supervisor: lambdas.lambda1,
    has_order: false,
}
